import { createPaginator } from "@smithy/core";
import { ChimeSDKMessagingClient } from "../ChimeSDKMessagingClient";
import { ListChannelFlowsCommand, } from "../commands/ListChannelFlowsCommand";
export const paginateListChannelFlows = createPaginator(ChimeSDKMessagingClient, ListChannelFlowsCommand, "NextToken", "NextToken", "MaxResults");
